import React from 'react';
import ReactDOM from 'react-dom/client';
import { scan } from 'react-scan';

import CONFIG from '@/config/config.ts';

import './i18n.ts';
import './index.css';
import { initErrorMonitoring } from '@/monitoring/sentry.util.ts';

import App from './App';

scan({
  enabled: CONFIG.PERFORMANCE_SCAN === 'true',
});
initErrorMonitoring();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
